module.exports = __webpack_public_path__ + "static/media/02.de83fd68.webp";